// Convierte un número a su representación en palabras en español (MXN).
// Ej: 15951.60 → "QUINCE MIL NOVECIENTOS CINCUENTA Y UN PESOS 60/100 M.N."

const UNIDADES = ['', 'UNO', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
const ESPECIALES = ['DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
const DECENAS = ['', '', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
const CENTENAS = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

const groupToWords = (n) => {
    if (n === 0) return '';
    if (n === 100) return 'CIEN';
    let out = '';
    const c = Math.floor(n / 100);
    const rem = n % 100;
    if (c > 0) out += CENTENAS[c] + ' ';
    if (rem < 10) {
        if (rem > 0) out += UNIDADES[rem];
    } else if (rem < 20) {
        out += ESPECIALES[rem - 10];
    } else if (rem < 30) {
        if (rem === 20) out += 'VEINTE';
        else out += 'VEINTI' + UNIDADES[rem - 20].toLowerCase().toUpperCase();
    } else {
        const d = Math.floor(rem / 10);
        const u = rem % 10;
        out += DECENAS[d];
        if (u > 0) out += ' Y ' + UNIDADES[u];
    }
    return out.trim();
};

export const numberToSpanishMXN = (amount) => {
    const n = Math.abs(Math.floor(Number(amount) || 0));
    const cents = Math.round(((Number(amount) || 0) - Math.floor(Number(amount) || 0)) * 100);

    if (n === 0) return `CERO PESOS ${String(cents).padStart(2, '0')}/100 M.N.`;

    const millions = Math.floor(n / 1000000);
    const thousands = Math.floor((n % 1000000) / 1000);
    const units = n % 1000;

    const parts = [];
    if (millions > 0) {
        if (millions === 1) parts.push('UN MILLÓN');
        else parts.push(groupToWords(millions) + ' MILLONES');
    }
    if (thousands > 0) {
        if (thousands === 1) parts.push('MIL');
        else parts.push(groupToWords(thousands) + ' MIL');
    }
    if (units > 0) parts.push(groupToWords(units));

    let text = parts.join(' ').trim();
    // "UNO" al final → "UN PESO"
    text = text.replace(/\bUNO\b$/, 'UN');

    const word = units === 1 && thousands === 0 && millions === 0 ? 'PESO' : 'PESOS';
    return `${text} ${word} ${String(cents).padStart(2, '0')}/100 M.N.`;
};
